import {
    messageItemTemplate,
    type MessageItemTemplate,
    type NoteObj,
} from './sharedMessageHelpers';

type RegExpMatchReturn = RegExpMatchArray | null;
const messagePreviewMatch = (): RegExpMatchReturn =>
    window.location.search.match(/cmsMessagePreview=([^&]+)/);

const messageSetsMatch = (): RegExpMatchReturn =>
    window.location.search.match(/message-sets:([^&]+)/);

const getMessagesFromUrl = (): NoteObj[] | null => {
    const match = messagePreviewMatch();
    if (match) {
        const data = JSON.parse(decodeURIComponent(match[1])) as MessageItemTemplate;
        return [messageItemTemplate(data)];
    }
    return null;
};

type UserTypeAndSetId = {
    userType: string;
    setId: string | null;
};

export const getUserTypeAndSetIdFromUrl = (): UserTypeAndSetId | null => {
    const setMatch = messageSetsMatch();
    if (setMatch) {
        const splits = setMatch[1].split('=');
        return {
            userType: splits[0],
            setId: splits.length > 1 ? splits[1] : null,
        };
    }
    return null;
};

export const isPreview = (): boolean => !!(messagePreviewMatch() || messageSetsMatch());

export const getPreview = (): { messages: ''; setParams: UserTypeAndSetId | null } | ObjectType => {
    if (isPreview()) {
        return {
            messages: getMessagesFromUrl(),
            setParams: getUserTypeAndSetIdFromUrl(),
        };
    }

    return {};
};
